import http from "../../utils/http";
import { toast } from "../../utils/toast";
// 본 지점 대기 목록
export const getBranchesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/branches/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 본 지점 신청
export const postCompaniesBranches = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/branches", body)
      .then((res) => {
        toast.success('본 지점 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신청 컨펌
export const updateBranches = (branchIdx, body) => {
  const { state } = body
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/branches/${branchIdx}`, body)
      .then((res) => {
        toast.success(`${state === 0 ? '거절' : '승인'} 되었습니다.`)
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};